import React, { useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import SponsorValueBreakdown from "../components/SponsorValueBreakdown";
import ValueDriversTable from "../components/ValueDriversTable";

const DashboardBetsson = ({ selectedCurrency }) => {
  const [activeFilters, setActiveFilters] = useState({
    channels: [],
    markets: [],
    rights: [],
  });

  const handleFiltersChange = (filters) => {
    setActiveFilters(filters);
  };

  return (
    <div className="container-fluid pt-4">
      <Row className="mb-4">
        <Col sm={12}>
          <Card className="mini-stat bg-card text-white">
            <CardBody>
              <SponsorValueBreakdown onFiltersChange={handleFiltersChange} />
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Value Drivers Table - only shown when filters are active */}
      {(activeFilters.channels.length > 0 ||
        activeFilters.markets.length > 0 ||
        activeFilters.rights.length > 0) && (
        <Row className="mb-4">
          <Col sm={12}>
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <ValueDriversTable
                  channels={activeFilters.channels}
                  markets={activeFilters.markets}
                  rights={activeFilters.rights}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(DashboardBetsson);
